import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface SessionExpirationModalProps {
  open: boolean;
  onClose: () => void;
  onRedirect: () => void;
  message?: string;
}

export const SessionExpirationModal: React.FC<SessionExpirationModalProps> = ({
  open,
  onClose,
  onRedirect,
  message = 'Your session has expired due to inactivity. Please login again to continue.',
}) => {
  const handleRedirect = () => {
    onRedirect();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <WarningIcon sx={{ color: '#606060', fontSize: 32 }} />
          <Typography variant="h6" component="div" sx={{ fontWeight: 500 }}>
            Session Expired
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ color: '#0f0f0f', mt: 1 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button
          onClick={handleRedirect}
          variant="contained"
          sx={{
            bgcolor: '#f1f3f4',
            color: '#0f0f0f',
            textTransform: 'none',
            borderRadius: '18px',
            px: 3,
            '&:hover': {
              bgcolor: '#e8eaed',
            },
          }}
        >
          Go to Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

